import { DefaultSettingsInterface } from '../../interfaces/default-settings/default-settings-interface';

export class DefaultSettingsModel implements DefaultSettingsInterface {
  [key: string]: any;
  activeWallet: string = 'horizontal';
  animationsDisable: boolean = false;
  zoomAccessibility: boolean = false;
  colorsDisable: boolean = false;
  defaultLanguage: string = 'pt-PT';
  expandedMenu: string = 'automatic';
  textSize: string = 'medium';

  constructor(init?: Partial<DefaultSettingsModel>) {
    Object.assign(this, init);
  }
}
